import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
import util from '@/libs/util';
import chat from '@/components/d2-chat';
import { mapActions, mapGetters } from 'vuex';
window.yl = YL;
export default {
  name: 'app',
  watch: {
    '$i18n.locale': 'i18nHandle'
  },
  components: {
    chat: chat
  },
  created: function created() {
    this.i18nHandle(this.$i18n.locale); // this.sizeSet('small')
    // this.themeSet('d2')
  },
  computed: _objectSpread({}, mapGetters('d2admin', {
    isImShow: 'message/isImShow',
    isImLogin: 'message/isImLogin',
    isImFormId: 'message/isImFormId'
  })),
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getUserSig();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: _objectSpread(_objectSpread({}, mapActions({
    sizeSet: 'd2admin/size/set',
    themeSet: 'd2admin/theme/set'
  })), {}, {
    i18nHandle: function i18nHandle(val, oldVal) {
      util.cookies.set('lang', val);
      document.querySelector('html').setAttribute('lang', val);
    }
  })
};